/**
 * Formats retailer names by removing "amazon-" prefix and properly capitalizing
 * e.g., "amazon-kohls" -> "Kohl's", "amazon-fedex" -> "FedEx"
 */
export function formatRetailerName(retailer: string): string {
  const retailerMap: Record<string, string> = {
    "amazon-kohls": "Kohl's",
    "amazon-khols": "Kohl's",
    "amazon-ups": "UPS",
    "amazon-fedex": "FedEx",
    "amazon-staples": "Staples",
    "amazon-wholefoods": "Whole Foods",
    "amazon-whole foods": "Whole Foods",
  };

  // Check if it's a known retailer code
  const formatted = retailerMap[retailer.toLowerCase()];
  if (formatted) {
    return formatted;
  }

  // Fallback: remove "amazon-" or "amazon " prefix and capitalize
  const cleaned = retailer
    .replace(/^amazon[-\s]*/i, "")
    .replace(/[()]/g, "");

  // Handle special cases
  if (cleaned.toLowerCase() === "kohls" || cleaned.toLowerCase() === "kohl's") {
    return "Kohl's";
  }
  if (cleaned.toLowerCase() === "ups") {
    return "UPS";
  }
  if (cleaned.toLowerCase() === "fedex") {
    return "FedEx";
  }
  if (cleaned.toLowerCase().includes("staples")) {
    return "Staples";
  }
  if (cleaned.toLowerCase().includes("wholefoods") || cleaned.toLowerCase().includes("whole foods")) {
    return "Whole Foods";
  }

  // Default: capitalize first letter of each word
  return cleaned
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
